import {Subscription} from "../models/subscription";

const DAY = 24 * 60 * 60 * 1000

/**
 * When a subscription stops giving access: `validity` days after `subscribedAt`. Lifetime plans,
 * and plans without a validity, never expire. Mirrors backend/src/utils/SubscriptionUtils.ts,
 * which the API's subscription check uses — keep the two in step.
 */
export const subscriptionExpiresAt = (subscription?: Subscription | null): number | null => {
    if (!subscription || subscription.isLifetime || !subscription.subscribedAt || !subscription.validity)
        return null
    return subscription.subscribedAt + subscription.validity * DAY
}

/** Expired once more days have passed since it started than its validity allows. */
export const isSubscriptionExpired = (subscription?: Subscription | null, now = Date.now()) => {
    const expiresAt = subscriptionExpiresAt(subscription)
    return !!subscription?.hasExpired || (expiresAt !== null && now >= expiresAt)
}
